import { render, staticRenderFns } from "./ResultsPages.vue?vue&type=template&id=0f7a0882&scoped=true&"
import script from "./ResultsPages.vue?vue&type=script&lang=js&"
export * from "./ResultsPages.vue?vue&type=script&lang=js&"
import style0 from "./ResultsPages.vue?vue&type=style&index=0&id=0f7a0882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7a0882",
  null
  
)

export default component.exports